import {Box, HStack, Show, VStack} from 'platform/foundation';

import {isNil, range} from 'ramda';

import i18n from '@dms/i18n';
import {SkeletonLoadingBox} from '@dms/shared';

import {SKELETON_GEOMETRY} from '../../../constants/SKELETON_GEOMETRY';
import {useSkeletonRowCount} from '../../../hooks/useSkeletonRowCount';
import {COMPACT_TABLE_GEOMETRY} from '../constants/COMPACT_TABLE_GEOMETRY';
import {Column} from '../utils/getSourcingTableColumns';

interface SourcingTableSkeletonProps {
  columns: Pick<Column, 'id' | 'width'>[];
}

export function SourcingTableSkeleton(props: SourcingTableSkeletonProps) {
  const rowCount = useSkeletonRowCount(SKELETON_GEOMETRY.tableRowMinHeightPx);
  return (
    <Box overflow="hidden" height="100%">
      <div role="status" aria-label={i18n.t('general.labels.loading')}>
        {range(0, rowCount).map((row) => (
          <Box
            key={row}
            paddingVertical={3}
            paddingHorizontal={COMPACT_TABLE_GEOMETRY.horizontalPadding}
            borderBottom="1px solid"
            borderColor="general.separator"
          >
            <HStack spacing={COMPACT_TABLE_GEOMETRY.columnSpacing} align="center">
              <HStack width={COMPACT_TABLE_GEOMETRY.checkboxColumnWidth} spacing={2}>
                <SkeletonLoadingBox isLoading width={4} height={4} />
                <SkeletonLoadingBox isLoading width={6} height={3} />
              </HStack>
              {props.columns.map((column) => (
                <Box
                  key={column.id}
                  width={column.width}
                  flex={isNil(column.width) ? 1 : undefined}
                >
                  <VStack spacing={2}>
                    <Box width={row % 2 === 0 ? '75%' : '60%'}>
                      <SkeletonLoadingBox isLoading height={3} />
                    </Box>
                    <Show when={isNil(column.width)}>
                      <Box width="45%">
                        <SkeletonLoadingBox isLoading height={2} />
                      </Box>
                    </Show>
                  </VStack>
                </Box>
              ))}
              <Box width={COMPACT_TABLE_GEOMETRY.trailingSpaceWidth}>
                <SkeletonLoadingBox isLoading width={3} height={3} />
              </Box>
            </HStack>
          </Box>
        ))}
      </div>
    </Box>
  );
}
